import {
	defaultSalOrderDtlDto,
	SalOrderDtlDto,
} from "src/dtos/salorder/salOrderDto";

export interface SAL1030_R01Dto extends SalOrderDtlDto {
	compNm: string;
	orderDtDisplay: string;
	startDate: string | null;
	endDate: string | null;
	empNo: string | null;
	empNm: string | null;
	itemStatus: string;
	dcAmtDisplay: number;
	remainingQty: number;
	remainingAmt: number;
	listLength: number | null;
	refetchListLength: number | null;
}

export const defaultSAL1030_R01Dto: SAL1030_R01Dto = {
	...defaultSalOrderDtlDto,
	compNm: '',
	orderDtDisplay: '',
	startDate: null,
	endDate: null,
	empNo: null,
	empNm: null,
	itemStatus: '-',
	dcAmtDisplay: 0,
	remainingQty: 0,
	remainingAmt: 0,
	listLength: null,
	refetchListLength: null,
};
